import { Component } from 'react';
import { connect } from 'react-redux';

import Icon from 'components/atoms/Icon';
import { RootState } from 'types';
import { MapControlsInterface } from 'types/functions';
import { twclsx } from 'utils/twclsx';

interface ControlsProps {
    openMenu?: boolean;
    openTool?: boolean;
    mapControls: MapControlsInterface;
    move: boolean;
    parent: string;
}

interface ControlsState {
    openMenu?: boolean;
    openTool?: boolean;
}

class Controls extends Component<ControlsProps, ControlsState> {
    constructor(props: ControlsProps) {
        super(props);
        this.state = {
            openMenu: props.openMenu,
            openTool: props.openTool,
        };
    }

    static getDerivedStateFromProps(props: ControlsProps, state: ControlsState) {
        if (props.openMenu !== state.openMenu || props.openTool !== state.openTool) {
            return { openMenu: props.openMenu, openTool: props.openTool };
        }

        return null;
    }

    render() {
        return (
            <div
                className={twclsx(
                    this.state.openMenu && this.props.move ? 'ml-controls' : 'ml-4',
                    'flex',
                    'flex-col',
                    'z-10',
                    'border',
                    'border-gray-500',
                    'margin-transition',
                    'rounded-md',
                    'select-none',
                    'justify-end',
                    'bg-white',
                    'absolute',
                    'top-5',
                    'left-0',
                    'h-16',
                    'w-8'
                )}
            >
                <div
                    className="flex items-center w-8"
                    onClick={() => {
                        this.props.mapControls[this.props.parent].zoomIn();
                    }}
                >
                    <Icon className="cursor-pointer w-8 h-8">
                        <path d="M9 12h6" />
                        <path d="M12 9v6" />
                    </Icon>
                </div>
                <div className="h-1 w-auto mx-1 border-b border-gray-400"></div>
                <div
                    className="flex items-center w-8"
                    onClick={() => {
                        this.props.mapControls[this.props.parent].zoomOut();
                    }}
                >
                    <Icon className="cursor-pointer w-8 h-8">
                        <path d="M9 12h6" />
                    </Icon>
                </div>
            </div>
        );
    }
}

const consolsStateToProps = (state: RootState) => ({
    openMenu: state.layout.layout.openMenu,
    openTool: state.layout.layout.openTool,
    mapControls: state.map.mapControls,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const consolsDispatchToProps = () => ({});

export default connect(consolsStateToProps, consolsDispatchToProps)(Controls);
